export default {"src":"/accounts/_next/static/media/Transactions.22d38479.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};